import React from 'react';

const CityFilter = ({ cities, activeCity, onCityChange }) => {
  return (
    <div className="flex flex-wrap gap-2 md:ml-auto">
      {cities.map(city => (
        <button
          key={city}
          onClick={() => onCityChange(city)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            activeCity === city
              ? 'bg-red-600 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-100'
          }`}
        >
          {city}
        </button>
      ))}
    </div>
  );
};

export default CityFilter;